import React from 'react';
import './VerificationLoader.css'
import { Image } from 'react-bootstrap';



const VerificationLoader = () => {



  return (
    <>
      <div className="verificationLoader">
        <div className='verificatio_loader_content'>
          <div className='m-auto text-center'>
            <Image src='/assets/images/loader-img.svg' className='mb-4 rotating-loader ' />
            <h4 className='font-16 font-weight-s-bold mb-4'>Please Wait...</h4>
            <p className='text-secondary font-13 font-weight-normal'>Please wait while we load your page. It won’t take more than a minute.</p>
          </div>
        </div>
      </div>
    </>
  )
}

export default VerificationLoader
